import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/60' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-16" role="navigation" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 cursor-pointer" aria-label="h漫画首页">
          <span className="text-2xl font-bold font-heading text-primary-500 whitespace-nowrap">h漫画</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                (link.href === '/' && location.pathname === '/') ||
                (link.href !== '/' && location.pathname.startsWith(link.href))
                  ? 'text-primary-500'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            className="hidden md:flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            aria-label="开始阅读"
          >
            <i className="ri-book-open-line"></i>
            开始阅读
          </button>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-200 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-300/60 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium py-2 transition-colors duration-200 cursor-pointer ${
                (link.href === '/' && location.pathname === '/') ||
                (link.href !== '/' && location.pathname.startsWith(link.href))
                  ? 'text-primary-500'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <button className="flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap mt-2">
            <i className="ri-book-open-line"></i>
            开始阅读
          </button>
        </div>
      )}
    </header>
  );
}